module.exports = __webpack_public_path__ + "img/interaction2.6362f93b.png";